import React from 'react';
import { Search } from 'lucide-react';

import { Badge } from '@/Modules/Core/Components/shadcn/badge';
import { Input } from '@/Modules/Core/Components/shadcn/input';
import TagInput from '@/Modules/Core/Components/Tags/TagInput';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Modules/Core/Components/shadcn/select';
import { PAGE_SIZE_OPTIONS } from './rolloutCatalogUtils';

const RolloutCatalogFilters = ({
  searchTerm,
  onSearchChange,
  selectedTags,
  tagOptions,
  onTagSearchChange,
  onTagsChange,
  tagsLoading = false,
  showingFrom,
  showingTo,
  filteredCount,
  reportedTotal,
  rowsPerPage,
  onRowsPerPageChange,
}) => (
  <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
    <div className="grid w-full gap-3 xl:max-w-3xl xl:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
      <div className="relative w-full">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search rollout name, description, or bug count..."
          className="h-[34px] pl-9"
        />
      </div>

      <TagInput
        value={selectedTags}
        options={tagOptions}
        onChange={onTagsChange}
        onSearchChange={onTagSearchChange}
        loading={tagsLoading}
        allowCreate={false}
        placeholder="Filter by tags"
        searchPlaceholder="Search tags"
        emptyMessage="No tags available"
        controlClassName="min-h-[34px] py-0.5"
      />
    </div>

    <div className="flex flex-wrap items-center gap-3 lg:justify-end">
      <Badge variant="secondary" className="rounded-xl px-3 py-1 text-[11px]">
        Showing {showingFrom}-{showingTo} of {filteredCount}
      </Badge>

      {searchTerm && reportedTotal > filteredCount ? (
        <Badge variant="outline" className="rounded-xl px-3 py-1 text-[11px]">
          {reportedTotal} records loaded
        </Badge>
      ) : null}

      <div className="flex items-center gap-2 text-[13px] text-muted-foreground">
        <span>Rows</span>
        <Select value={rowsPerPage} onValueChange={onRowsPerPageChange}>
          <SelectTrigger className="w-[96px]">
            <SelectValue placeholder="10" />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);

export default RolloutCatalogFilters;
